var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isManager
    ? _c("div", [
        _c("section", { attrs: { id: "user" } }, [
          !_vm.isPrivateUser
            ? _c("h2", [_vm._v("企業情報入力")])
            : _c("h2", [_vm._v("会員連絡先入力")]),
          _vm._v(" "),
          _c("div", { staticClass: "input_list" }, [
            _c("ul", [
              !_vm.isPrivateUser
                ? _c("li", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.label.corpName))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "important small_text" }, [
                        _vm._v("必須")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.corpForm.corpName,
                          expression: "corpForm.corpName",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: { type: "text", maxlength: "32" },
                      domProps: { value: _vm.corpForm.corpName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.corpForm,
                            "corpName",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.corpName
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.corpName))
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isPrivateUser
                ? _c("li", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.label.corpBranchName))])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.corpForm.corpBranchName,
                          expression: "corpForm.corpBranchName",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: { type: "text", maxlength: "32" },
                      domProps: { value: _vm.corpForm.corpBranchName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.corpForm,
                            "corpBranchName",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.corpBranchName
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.corpBranchName))
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isPrivateUser
                ? _c("li", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.label.email))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "important small_text" }, [
                        _vm._v("必須")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "small_p" }, [
                        _vm._v(
                          "仮登録したアドレスと間違いがないかご確認ください。"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.corpForm.email,
                          expression: "corpForm.email",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "****@domans.co.jp",
                        disabled: !_vm.isEdit,
                        maxlength: "128"
                      },
                      domProps: { value: _vm.corpForm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.corpForm,
                            "email",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.email
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.email))
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.label.tel))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "small_p" }, [
                    _vm._v("（半角数値、ハイフン不要）")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "important small_text" }, [
                    _vm._v("必須")
                  ])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.corpForm.tel,
                      expression: "corpForm.tel",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "text",
                    oninput: "if(value.length>11)value=value.slice(0,11)",
                    placeholder: "0123456789",
                    maxlength: "11"
                  },
                  domProps: { value: _vm.corpForm.tel },
                  on: {
                    keypress: _vm.validateNumber,
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.corpForm,
                          "tel",
                          $event.target.value.trim()
                        )
                      },
                      function($event) {
                        _vm.corpForm.tel = _vm.inputRestNumber($event)
                      }
                    ],
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.tel
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errors.tel))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.label.fax))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "small_p" }, [
                    _vm._v("（半角数値、ハイフン不要）")
                  ])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.corpForm.fax,
                      expression: "corpForm.fax",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { type: "text", maxlength: "16" },
                  domProps: { value: _vm.corpForm.fax },
                  on: {
                    keypress: _vm.validateNumber,
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.corpForm,
                          "fax",
                          $event.target.value.trim()
                        )
                      },
                      function($event) {
                        _vm.corpForm.fax = _vm.inputRestNumber($event)
                      }
                    ],
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.fax
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errors.fax))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.label.postcd))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "small_p" }, [
                    _vm._v("（半角数値、ハイフン不要）")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "important small_text" }, [
                    _vm._v("必須")
                  ])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.corpForm.postcd,
                      expression: "corpForm.postcd",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { type: "text", maxlength: "7" },
                  domProps: { value: _vm.corpForm.postcd },
                  on: {
                    keypress: _vm.validateNumber,
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.corpForm,
                          "postcd",
                          $event.target.value.trim()
                        )
                      },
                      function($event) {
                        _vm.corpForm.postcd = _vm.inputRestNumber($event)
                      }
                    ],
                    blur: [
                      _vm.addressCompletion,
                      function($event) {
                        _vm.$forceUpdate()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _vm.errors.postcd
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errors.postcd))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "input_text2" }, [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.label.state))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "important small_text" }, [
                    _vm._v("必須")
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.corpForm.state,
                        expression: "corpForm.state",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "都道府県",
                      maxlength: "32"
                    },
                    domProps: { value: _vm.corpForm.state },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.corpForm,
                          "state",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "space" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.corpForm.city,
                        expression: "corpForm.city",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "市区町村",
                      maxlength: "32"
                    },
                    domProps: { value: _vm.corpForm.city },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.corpForm,
                          "city",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.errors.state
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errors.state))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.label.street))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "important small_text" }, [
                    _vm._v("必須")
                  ])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.corpForm.street,
                      expression: "corpForm.street",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { type: "text", maxlength: "32" },
                  domProps: { value: _vm.corpForm.street },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.corpForm,
                        "street",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.street
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errors.street))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              !_vm.isEdit
                ? _c("li", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.label.inviteCode))])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.corpForm.inviteCode,
                          expression: "corpForm.inviteCode",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: { type: "text", maxlength: "16" },
                      domProps: { value: _vm.corpForm.inviteCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.corpForm,
                            "inviteCode",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.inviteErrMessage
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.inviteErrMessage))
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              Object.keys(_vm.errors).length > 0
                ? _c("div", { staticClass: "error_text" }, [
                    _vm._v(
                      "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ece5754", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ece5754","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/user/DcCorpInfo.vue
// module id = null
// module chunks = 